<template>
  <div class="change-page v-service">
    <van-cell-group style="background: white">
      <van-cell title="电站名称"
                :value="chargePrepareInfo.staName | formatNullValue">
      </van-cell>
      <van-cell title="电站地址"
                :value="chargePrepareInfo.staAddress | formatNullValue">
      </van-cell>
      <van-cell title="电桩名称"
                :value="chargePrepareInfo.pileName | formatNullValue">
      </van-cell>
      <van-cell title="枪口编号"
                :value="chargePrepareInfo.gunName">
      </van-cell>
      <van-cell title="设备类型"
                :value="chargePrepareInfo.deviceTypeDesc | formatNullValue">
      </van-cell>
      <van-cell title="SOC上限"
                is-link
                @click="openSoc"
                v-if="!chargePrepareInfo.socIsClosed && !chargePrepareInfo.hlht">
        达到设定值自动结束充电 <span class="soc-value">{{soc}}</span> %
      </van-cell>
      <van-cell title="车牌号"
                v-if="!chargePrepareInfo.hlht"
                :value="carNo | formatNullValue"
                is-link
                @click="goSelectCar">
      </van-cell>
      <!-- <van-cell>
          <template #title>
            <div class="custom-title" @click="couponTipsShow = true">使用优惠券 <img src="../../../assets/image/wen.png" alt=""></div>
          </template>
          <van-switch v-model="checked"  size="0.45rem"  active-color="#14CC80" />
      </van-cell> -->
      <van-cell :is-link="!chargePrepareInfo.hlht">
        <template #title>
          <div class="van-cell__title custom-title"><span>使用优惠券</span>  <img src="../../../assets/image/wen.png" alt="" ></div>
        </template>
        <div class="van-cell__value" v-if="!chargePrepareInfo.hlht" @click="couponTypeShow = true">{{couponTypeObj[couponType]}}</div>
        <div class="van-cell__value" v-else>{{couponTypeObj[couponType]}}</div>
      </van-cell>
      <van-cell title="充电策略"
                 :is-link="!chargePrepareInfo.hlht"
                @click="openChargingModel">
                {{chargingModelObj[chargingModel]}}
                <template v-if="chargingModel == 4"><span v-if="modelHour > 0">{{modelHour}}时</span>{{modelMinute}}分</template>
                <template v-if="chargingModel == 3 && modelMoney>0">{{modelMoney}}元</template>
                <template v-if="chargingModel == 2 && modelDl>0">{{modelDl}}度</template>
            
      </van-cell>
    </van-cell-group>
    <div class="ready-rate-box"
         v-if="!chargePrepareInfo.hlht">
      <div class="ready-rate-icon">
        <img src="../../../assets/image/rate-icon.png">
      </div>
      <div class="ready-rate-flex">
        <div class="ready-rate-header">
          <div class="title">
            {{accInfo.vipTypeDesc}}
            <span class="before-discount" v-if="beforeDiscount && beforeDiscount != getRate(accInfo.currFeeInfos)">{{beforeDiscount}}元/度</span>
            <span class="main-color"> {{getRate(accInfo.currFeeInfos)}}元/度</span>
          </div>
          <div class="header-right"
               @click="openRateSelect"
               v-if="chargePrepareInfo.acctPriceList && chargePrepareInfo.acctPriceList.length > 1">切换账户</div>
        </div>
        <div class="ready-rate-content"
             v-for="(item,index) in currFeeInfos"
             :key="index">
          <div class="rate-content">{{item.feeTypeDesc}}({{$common.formatDelayTime(item.beginTime)}}~{{$common.formatDelayTime(item.endTime)}})</div>
          <div class="rate-content-right">{{item.price}}元/{{item.feeType == 3 ? '分钟': '度'}} </div>
        </div>
      </div>
    </div>
    <div class="ready-hlhtrate-box"
         v-if="!chargePrepareInfo.hlht">
      <!-- 互联互通 -->
      <div class="hlht-box"
           v-for="(item,index) in chargePrepareInfo.hlhtBizPolicies"
           :key="index">
        <div class="hlht-time"> {{item.startTime}} </div>
        <div class="hlht-flex">
          <p>电费:{{item.elecPrice}}</p>
          <p>服务费:{{item.sevicePrice}}</p>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <div class="lowest-charge">
        {{chargePrepareInfo.gunStatus !== 7? '请注意，余额用完将自动结束充电！': '请插抢'}}
      </div>
      <pi-button block
                 type="primary"
                 v-if="chargePrepareInfo.gunStatus == 1"
                 @click="startChargeBtn">
        开始充电
      </pi-button>
      <pi-button block
                 type="default"
                 v-else-if="chargePrepareInfo.gunStatus == 0" >
        枪口正在充电中
      </pi-button>
      <pi-button block
                 type="default"
                 v-else-if="chargePrepareInfo.gunStatus == 7">
        请插枪，准备充电
      </pi-button>
      <pi-button block
                 @click="startCharge"
                 v-else>
        {{chargePrepareInfo.gunStatusDesc}}
      </pi-button>
      <!-- <pi-button block
                 style="margin-top:0.2rem"
                 @click="getChargePrepareInfo">刷新设备</pi-button> -->
      <!-- <div v-if="chargePrepareInfo.gunStatus !== 1 || !chargePrepareInfo.serialNo"
           class="button1"
           :class="{disable: true}"
           @click="startCharge">
        请插枪，准备充电{{chargePrepareInfo.currPrice}}元/度
      </div> 
      <div v-else
           class="button1"
           :class="{disable: false}"
           @click="startCharge">
        已插枪，开始充电 {{chargePrepareInfo.currPrice}}元/度
      </div>-->
    </div>
    <van-overlay :show="readyAccount"
                 v-if="chargePrepareInfo.acctPriceList">
      <div class="account-wrapper">
        <div class="ready-account">
          <div class="ready-account-title">请选择账户</div>
          <ul class="ready-account-content">
            <li class="ready-account-item"
                :class="{'active': selectAccInfo.accountPkId == item.accountPkId}"
                v-for="(item,index) in chargePrepareInfo.acctPriceList"
                :key="index"
                @click="selectUser(index)">
              {{getRate(item.currFeeInfos)}}元/度 {{item.vipTypeDesc}}
              <template v-if="item.vipType != 3">
              （余额：{{userBalanceAmount}}）
              </template>
            </li>
          </ul>
          <div class="overlay-btn">
            <div class="overlay-btn-flex confirm"
                 @click="confirmRate">确定</div>
            <div class="overlay-btn-flex"
                 @click="cancelClick">取消</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="chargingModeModel">
      <div class="account-wrapper">
        <div class="ready-account" style="width:6rem">
          <div class="ready-account-title">请选择充电模式</div>
          <div class="ready-account-content charging-moda">
            <van-radio-group v-model="consumptionPattern" direction="horizontal">
              <van-radio :name="index" checked-color="#14cc80" v-for="(item,index) in consumptionPatternObj" :key="index">{{item}}</van-radio>
            </van-radio-group>
          </div>
          <div class="overlay-btn">
            <div class="overlay-btn-flex confirm"
                 @click="chargingModeConfirm">确定</div>
            <div class="overlay-btn-flex"
                 @click="chargingModeCancel">取消</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- <van-popup v-model="popupShow"
               position="bottom">
      <van-picker title="SOC上限"
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="onCancel"
                  :default-index="defaultIndex" />
    </van-popup> -->
    <pi-select-soc v-if="!chargePrepareInfo.socIsClosed && !chargePrepareInfo.hlht" :soc="soc" :defaultSoc="chargePrepareInfo.defaultSoc" :floorSoc="chargePrepareInfo.floorSoc || 50" ref="selectSoc" @change="selectSocChange"
    ></pi-select-soc>
    <van-popup v-model="couponTipsShow">
      <div class="coupon-tips">
        <div class="coupon-tips-title">使用优惠券</div>
        <div class="coupon-tips-content">
          <p class="p-title">1.开启</p>
          <p class="p-content">订单结算时，系统会根据充电金额判断是否达到使用优惠券的条件，若达不到，本次结算将不使用优惠券；若达到，系统将以最快过期的最高面额的原则进行优惠券选择抵扣。</p>
          <p class="p-title">2.关闭</p>
          <p class="p-content">订单结算时不使用优惠券。</p>
        </div>
        <div class="coupon-btn" @click="couponTipsShow = false">确定</div>
      </div>
    </van-popup>
    <van-popup v-model="couponTypeShow" position="bottom" >
      <ul>
        <li class="coupon-type-item" @click="selectCouponType(item.itemKey)" v-for="(item, index) in couponTypeList" :key="index">
          {{item.itemValue}}
          <img v-show="couponType == item.itemKey" src="../../../assets/img/ic_pay_success.png" />
        </li>
      </ul>
    </van-popup>
    <van-popup v-model="chargingModelShow" position="bottom" >
      <ul>
        <li class="coupon-type-item" @click="selectChargingModel(item.itemKey)" v-for="(item, index) in chargingModelList" :key="index">
          {{item.itemValue}}
          <img v-show="chargingModel == item.itemKey" src="../../../assets/img/ic_pay_success.png" />
        </li>
        
      </ul>
      
    </van-popup>
    <van-popup v-model="timeModelShow" position="bottom" >
      <van-picker value-key="name" @cancel="timeModelShow = false" @confirm="timeConfirm" show-toolbar title="请设置充电时间" :columns="columnsTime" />
    </van-popup>
    <van-popup v-model="moneyModelShow" position="bottom" >
      <van-picker value-key="name" @cancel="moneyModelShow = false" @confirm="moneyConfirm" show-toolbar title="请设置充电金额(元)" :columns="columnsMoney" />
    </van-popup>
    <van-popup v-model="dlModelShow" position="bottom" >
      <van-picker value-key="name" @cancel="dlModelShow = false" @confirm="dlConfirm" show-toolbar title="请设置充电电量(度)" :columns="columnsDl" />
    </van-popup>
  </div>
</template>

<script>
import {
  getChargePrepareInfo,
  startCharge,
  hlhtStartCharge,
  getCheckAcct,
  getCarList,
  getDictInfoList,
  getOprCongifInfo
} from "../../../common/api/index";
import { Button, Cell, CellGroup, Overlay, Picker, Popup, Switch,RadioGroup, Radio   } from "vant";
// import { getStationDetailFee } from "../../../common/api";
import selectSoc from './select-soc.vue'
export default {
  name: "change-page",
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Overlay.name]: Overlay,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [selectSoc.name]: selectSoc,
    [Switch.name]: Switch,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      chargingModeModel: false,
      consumptionPattern: '1',// 充电模式  1.5.2 版本
      consumptionPatternObj: {
        '1': '余额充电',
        '2': '即充即退',
      },
      timeModelShow:false,
      columnsTime: [],
      moneyModelShow: false,
      columnsMoney: [],
      dlModelShow: false,
      columnsDl: [],
      vipType: {
        1: "普通会员",
        2: "企业会员",
        3: "企业支付",
      },
      couponTipsShow: false,
      couponTypeShow: false,
      couponType: '',
      couponTypeObj: {
        '1': '时间优先',
        '2': '金额优先',
      },
      couponTypeList: [],
      currElecPrice: null,
      chargePrepareInfo: {
        chargeDelayFeeVo: {},
      },
      accountPkId: "",
      gunNumber: "",
      serialNumber: "",
      timer: null,
      getTimer: null,
      readyAccount: false,
      accInfo: {}, // 已选择的费率
      selectAccInfo: {}, // 正在选择的费率
      currFeeInfos: {},
      rateType: 1, // 默认费率 普通费率
      feeDetail: {},
      isInit: false,
      userAccountPkId: "", // 普通用户类型的ID，企业会员时要传这个
      userBalanceAmount: "", // 普通用户类型的ID，企业会员时金额要显示这个
      chargingModelShow: false,
      chargingModel: "", // 充电策略
      chargingModelObj: {}, // 充电策略列表
      chargingModelList: [], // 充电策略列表
      columns: [100, 99, 98, 97, 96],
      // popupShow: false,
      defaultIndex: 0,
      soc: 0,

      readyForm: {
        customInfo: "",
        gunPkId: "",
        operatorId: "",
      },
      carList: [],
      carNo: '',
      checked: false,
      modelMoney: '',
      modelDl: '',
      modelHour: '',
      modelMinute: '',
      beforeDiscount: null, // 有调价活动时,优惠前的金额 
      oprInfo: {}
    };
  },
  mounted() {
    let query = this.$route.query;
    this.readyForm.customInfo = query.customInfo;
    this.readyForm.gunPkId = query.gunPkId;
    this.readyForm.operatorId = query.operatorId;
    this.readyForm.enterWay = query.enterWay;
    let selectCar = this.$common.get('selectCar',1);
    if(selectCar && typeof selectCar == 'object' && selectCar.carNo != ''){
      this.carNo = selectCar.carNo;
    }else{
      this.getCarList();
    }
    this.$common.remove('selectCar',1);
    
    // this.serialNumber = this.$route.query.serialNumber;
    // this.gunNumber = this.$route.query.gunNumber;
    this.getChargePrepareInfo();
    this.pollUpdate();
    this.getOprCongifInfo();
  },
  methods: {
    async getOprCongifInfo(){
      let ret = await getOprCongifInfo({});
      if (
          ret.status === this.$config.ajaxStatus &&
          ret.data.length > 0
        ) {
          this.oprInfo = ret.data[0];
        }
    },
    openChargingModel(){  
      if(!this.chargePrepareInfo.hlht){
        this.chargingModelShow = true;
      }
    },
    
    initModelData(){
      let host = [];
      let minute = [];
      // let min = [];
      let max = [];
      let maxList = [];
      for(let i=0;i<60;i++){
        if(i<16){
          host.push({value:i,name: i + '时'})
        }
        minute.push({value:i,name: i + '分'})
        max.push({value:i,name: i })
      }
      for(let i=1;i<=100;i++){
        maxList.push({value:i,name: i })
      } 
      this.columnsTime = [
        {
          values: host,
          defaultIndex: this.modelHour,
        },
        {
          values: minute,
          defaultIndex: this.modelMinute,
        }
      ];
      
      let moneyIndex = 0;
      if(this.modelMoney){
        maxList.map((item,index)=>{
          if(item.value == this.modelMoney){
            moneyIndex = index;
          }
        })
      }
      this.columnsMoney = [
        {
          values: maxList,
          defaultIndex: moneyIndex,
        },
      ]
      let dlIndex = 0;
      if(this.modelDl){
        maxList.map((item,index)=>{
          if(item.value == this.modelDl){
            dlIndex = index;
          }
        })
      }
      this.columnsDl = [
        {
          values: maxList,
          defaultIndex: dlIndex,
        },
      ]
    },
    timeConfirm(val,vals){
      this.modelHour = vals[0];
      this.modelMinute = vals[1];
      this.timeModelShow = false;
      this.chargingModelShow = false;
      this.saveDiscountStrategy();
    },
    moneyConfirm(val){
      let money = val[0].value;
      if(this.accInfo.vipType == 1 && money > this.userBalanceAmount){
        this.$toast("您的账户余额为"+this.userBalanceAmount+"，不足" + money + '元，请重新选择');
      }else{
        this.modelMoney = money;
        this.moneyModelShow = false;
        this.chargingModelShow = false;
        this.saveDiscountStrategy();
      }
    },
    dlConfirm(val){
      this.modelDl = val[0].value;
      this.dlModelShow = false;
      this.chargingModelShow = false;
      this.saveDiscountStrategy();
    },
    getTypeList () {
      return new Promise((resolve, reject) => {
        getDictInfoList({
          typeIdList: '12385,12390',
        }, true).then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            
            if(data.data.length > 0){
              let couponTypeObj = {};
              let chargingModelList = {};
              data.data.map(item=>{
                if(item.typePkId == 12385){
                  couponTypeObj[item.itemKey] = item.itemValue;
                  this.couponTypeList.push(item);
                }
                if(item.typePkId == 12390){
                  chargingModelList[item.itemKey] = item.itemValue;
                  this.chargingModelList.push(item);
                }
              })
              this.couponTypeObj = couponTypeObj;
              this.chargingModelObj = chargingModelList;
              let discountStrategy = this.$common.get('discountStrategy');
              let chargingModelData = this.$common.get('chargingModelData');
              
              if(this.chargePrepareInfo.hlht){
                this.couponType = '0';
                this.chargingModel = '1'
              }else{
                if (discountStrategy) {
                  this.couponType = discountStrategy;
                } else {
                  this.couponType = '1';//this.couponTypeList[0].itemKey;
                }
                if (chargingModelData) {
                  if(chargingModelData.modelHour == '' && chargingModelData.modelMinute == ''){
                    chargingModelData.modelHour = 3;
                  }
                  this.chargingModel = chargingModelData.chargingModel || '1';
                  this.modelMoney = chargingModelData.modelMoney && chargingModelData.modelMoney <= this.userBalanceAmount ? chargingModelData.modelMoney:10;
                  this.modelDl = chargingModelData.modelDl || 30;
                  this.modelHour = chargingModelData.modelHour;
                  this.modelMinute = chargingModelData.modelMinute;
                } else {
                  this.chargingModel = this.chargingModelList[0].itemKey;
                  this.modelMoney = this.userBalanceAmount > 30 ? 30 : this.userBalanceAmount;
                  this.modelDl = 30;
                  this.modelHour = 3;
                  this.modelMinute = 0;
                }
                this.initModelData();
                this.saveDiscountStrategy();
                resolve();
              }
            }
            
          } else {
            reject();
          }

        }).catch((error) => {
          console.log(error);
          reject();
        });
      })
    },
    selectCouponType(val){
      this.couponTypeShow = false;
      this.couponType = val;
      this.saveDiscountStrategy();
    },
    selectChargingModel(val){
      this.chargingModel = val;
      if(val == '1'){
        this.chargingModelShow = false;
        this.saveDiscountStrategy();
      }else if(val == '4'){
        this.timeModelShow = true;
      }else if(val == '3'){
        this.moneyModelShow = true;
      }else if(val == '2'){
        this.dlModelShow = true;
      }
      
    },
    saveDiscountStrategy(){
      // 即充即退模式不保存
      if(!this.getRechargeRefundMoney()){
        this.$common.save('discountStrategy',this.couponType);
        this.$common.save('chargingModelData',{
          chargingModel: this.chargingModel,
          modelMoney: this.modelMoney,
          modelDl: this.modelDl,
          modelHour: this.modelHour,
          modelMinute: this.modelMinute,
        });
      }
    },
    selectSocChange(value){
      this.soc = value;
    },

    getCarList(){
      getCarList(null)
        .then(response => {
          if ( response.status == this.$config.ajaxStatus) {
            this.carList = response.data;
            
            this.carList.map(item=>{
              if(item.hasDefault){
                this.carNo = item.carNo;
              }
            })
            if(this.carNo == '' && this.carList.length > 0){
              this.carNo = this.carList[0].carNo
            }
          }

        })
    },
    goSelectCar(){
      if(this.carNo == ''){
        this.$router.push({
          name: "my-license-plate-add",
        });
      }else{
        this.$router.push({
          name: "car-list",
          query: {
            type: 'select'
          }
        });
      }
    },
    
    getChargePrepareInfo() {
      getChargePrepareInfo(this.readyForm,false)
        .then(async(data) => {
          if (data.status === this.$config.ajaxStatus) {
            if (!data.code || data.code == "SUCCESS") {
              // 桩没问题
              this.chargePrepareInfo = data.data[0];
              // this.chargePrepareInfo.hlht = true;
              if(this.couponTypeList.length == 0){
                await this.getTypeList();
              }

              if(this.soc == ''){
                this.soc = this.chargePrepareInfo.defaultSoc || 100;
              }
              let beforeDiscount = 0;
              if(this.chargePrepareInfo.currStandardFeeInfos && this.chargePrepareInfo.currStandardFeeInfos.length> 0){
                this.chargePrepareInfo.currStandardFeeInfos.map(item=>{
                  if(item.feeType != 3){
                    beforeDiscount = beforeDiscount + item.price;
                  }
                  
                })
                this.beforeDiscount = beforeDiscount.toFixed(2);
              }
              
              if (
                this.chargePrepareInfo.acctPriceList &&
                this.chargePrepareInfo.acctPriceList.length > 0
              ) {
                this.chargePrepareInfo.acctPriceList.map((item) => {
                  if (item.vipType == 1) {
                    this.userAccountPkId = item.accountPkId;
                    this.userBalanceAmount = item.balanceAmount;
                  }
                });
                if (!this.isInit) {
                  // 第一次进来
                  
                  this.initColumns();
                  this.isInit = true;

                  let rechargeRefundMoney = this.getRechargeRefundMoney()
                  if(rechargeRefundMoney){
                    // 找到进去前保存的账号
                    let selectAccInfo = this.$common.get('selectAccInfo');
                    let index = 0;
                    if(selectAccInfo){
                      this.chargePrepareInfo.acctPriceList.map((item, i) => {
                        if (item.accountPkId == selectAccInfo.accountPkId) {
                         index = i
                        }
                      });
                    }
                    this.selectUser(index);
                    
                    // 如果是即充即退直接充电
                    this.confirmRate(()=>{
                      this.getRechargeRefundSuccess(rechargeRefundMoney);
                    });
                  }else{
                    this.selectUser(0);
                    if (this.chargePrepareInfo.acctPriceList.length > 1) {
                      this.readyAccount = true;
                    } else {
                      this.cancelClick();
                    }
                  }
                } else {
                  // 刷新
                  if(this.accountPkId == ''){
                    this.chargePrepareInfo.acctPriceList.map((item, index) => {
                      if (item.accountPkId == this.accountPkId) {
                        this.selectUser(index);
                      }
                    });
                  }
                }
              }
            }
            //  else if (data.code == "202002") {
            //   this.timeOut();
            //   this.$dialog
            //     .confirm({
            //       message: data.msg,
            //       confirmButtonText: "充值",
            //       confirmButtonColor: "#14CC80",
            //       closeOnPopstate: true,
            //     })
            //     .then(() => {
            //       // on confirm
            //       this.$router.push({
            //         name: "recharge",
            //       });
            //     })
            //     .catch(() => {
            //       this.$common.goBack();
            //     });
            //   return;
            // } 
            else {
              this.timeOut();
              this.$dialog
                .confirm({
                  message: data.msg,
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                .then(() => {
                  this.$common.goBack();
                })
                .catch(() => {
                  this.$common.goBack();
                });
              return;
            }
          } else if (
            data.data &&
            data.data.length > 0 &&
            data.data[0].errorType
          ) {
            this.timeOut();
            this.$common.showTargetDialog(
              this.$dialog,
              this.$router,
              data,
              true,
              this.accountPkId
            );
          } else {
            this.timeOut();
            this.$dialog
              .alert({
                message: data.msg + this.$common.codeMsg(data.code),
                confirmButtonText: "确定",
                confirmButtonColor: "#14CC80",
                closeOnPopstate: true,
              })
              .then(() => {
                this.$router.go(-1);
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.timeOut();
          console.log(error);
        });
    },
    openRateSelect() {
      this.selectAccInfo = JSON.parse(JSON.stringify(this.accInfo));
      this.readyAccount = true;
    },
    selectUser(index) {
      this.selectAccInfo = this.chargePrepareInfo.acctPriceList[index];
    },
    async confirmRate(callBack) {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: "加载中...",
        });
        // await this.getCheckAcct();
        this.accInfo = JSON.parse(JSON.stringify(this.selectAccInfo));
        this.accountPkId = this.accInfo.accountPkId;
        this.currFeeInfos = this.sortList(this.accInfo.currFeeInfos, "feeType");
        this.readyAccount = false;
        this.$toast.clear();
        if(typeof callBack == 'function'){
          callBack();
        }
    },
    cancelClick() {
      if (!this.accInfo.accountPkId) {
        this.accInfo = JSON.parse(JSON.stringify(this.selectAccInfo));

        this.accountPkId = this.accInfo.accountPkId;
        this.currFeeInfos = this.sortList(this.accInfo.currFeeInfos, "feeType");
      }
      this.readyAccount = false;
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    sortList(arr, str) {
      // 数组排序
      if (Object.prototype.toString.call(arr).slice(8, -1) === "Array") {
        var returnArr = arr.sort(this.compare(str));
        return returnArr;
      } else {
        return arr;
      }
    },
    // selectAcc(item) {
    //   this.accInfo = item;
    // },
    getRate(list) {
      let rate = 0;
      if (list) {
        list.map((item) => {
          if (item.feeType == 1 || item.feeType == 2) {
            rate = rate + item.price;
          }
        });
      }
      return rate.toFixed(3);
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.getChargePrepareInfo();
    },
    gotoPriceInfo() {
      this.$common.save("priceInfo", {
        chargeDelayFeeVo: this.chargePrepareInfo.chargeDelayFeeVo,
        chargeFeeVo: this.chargePrepareInfo.chargeFeeVo,
      });
      this.$router.push({ name: "charging/success/price" });
    },
    noMoneyTips(text){
      this.$dialog
      .confirm({
        message: text,
        confirmButtonText: "充值",
        confirmButtonColor: "#14CC80",
      })
      .then(() => {
        this.$router.push({
          name: "recharge",
        });
      }).catch(() => {
        
      });
    },
    // 验证账户是否可用
    getCheckAcct() {
      
      return new Promise((resolve) => {
        let accountPkId = this.selectAccInfo.accountPkId;
        if(this.selectAccInfo.vipType == 2){
          accountPkId = this.userAccountPkId
        }
        getCheckAcct({
          accountPkId: accountPkId,
        })
          .then((ret) => {
            if(ret.status === this.$config.ajaxStatus){
              
              if(ret.code == '202002'){
                this.$toast.clear();
                this.noMoneyTips(ret.msg);
              }else{
                if (ret.data.length == 0) {
                  resolve(ret);
                } else {
                  this.$toast(ret.data.join(","));
                }
              }
            }else{
              this.$toast.clear();
              this.$dialog
              .alert({
                message: ret.msg+ this.$common.codeMsg(ret.code),
                confirmButtonText: "确定",
                confirmButtonColor: "#14CC80",
                closeOnPopstate: true,
              }).then(() => {
                this.$common.goBack();
              })
            }
          })
          .catch((error) => {
            this.$toast(error);
          });
      });
    },
    startCharge() {
      let accountPkId = "";
      if (this.accInfo.vipType == 2) {
        // 企业会员时，还是用普通会员那个 accountPkId 来提交
        accountPkId = this.userAccountPkId + "";
      } else {
        accountPkId = this.accountPkId;
      }
      let enterWay = this.$route.query.enterWay || '0';
      if (this.chargePrepareInfo.hlht) {
        hlhtStartCharge({
          accountPkId: accountPkId,
          customInfo: this.readyForm.customInfo,
          // gunPkId: this.readyForm.gunPkId,
          gunPkId: this.chargePrepareInfo.gunPkId,
          operatorId: this.readyForm.operatorId || '',
          staFeeDesc: this.chargePrepareInfo.staFeeDesc,
          vipType: this.selectAccInfo.vipType,
          carNo: this.carNo,
          staPkId: this.chargePrepareInfo.staPkId,
          consumptionPattern: this.consumptionPattern,
          enterWay: enterWay // 0 点击列表  1 扫描二维号
          // discountStrategy: this.couponType,
          // chargingModel: this.chargingModel
          // deviceType: this.chargePrepareInfo.deviceType,
          // elecFeePkId: this.accInfo.elecFeePkId,
          // topSoc: this.soc,
        })
          .then((data) => {
            this.saveDiscountStrategy();
            if (data.status === this.$config.ajaxStatus) {
              this.$router.replace({
                name: "charge/launching",
                query: {
                  accountPkId: accountPkId,
                  gunNumber: this.gunNumber,
                  serialNumber: this.serialNumber,
                  orderNo: data.data[0],
                  replace: true
                },
              });
            } else {
              this.$dialog
                .alert({
                  message: data.msg + this.$common.codeMsg(data.code),
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                // .then(() => {
                //   this.refresh();
                // })
                // .catch(() => {});
            }
            
          })
          .catch((error) => {
            console.log(error);
            this.$toast("启动失败");
          });
      } else {
        let chargingModelValue = '';
        
        if(this.chargingModel == '2'){
          if(this.modelDl > 0){
            chargingModelValue = this.modelDl;
          }else{
            this.$toast('请选择正确的电量');
            this.chargingModelShow = true;
            this.dlModelShow = true;
            return;
          }
        }else if(this.chargingModel == '3'){
          if(this.accInfo.vipType == 1 && this.modelMoney > this.userBalanceAmount){
            this.chargingModelShow = true;
            this.moneyModelShow = true;
            setTimeout(()=>{
              this.$toast("您的账户余额为"+this.userBalanceAmount+"，不足" + this.modelMoney + '元，请重新选择');
            },300)
            
            return;
          }else if(this.modelMoney > 0){
            chargingModelValue = this.modelMoney;
          }  else{
            this.$toast('请选择正确的金额');
            this.chargingModelShow = true;
            this.moneyModelShow = true;
            return;
          }
          
        }else if(this.chargingModel == '4'){
          let time = '';
          
          if(this.modelHour >= 0 && this.modelMinute >= 0){
            let modelHour = 0;
            let modelMinute = 0;
            if(this.modelHour == ''){
              modelHour = 0;
            }else{
              modelHour = this.modelHour;
            }
            if(this.modelMinute == ''){
              modelMinute = 0;
            }else{
              modelMinute = this.modelMinute;
            }
            time = parseInt(modelHour) * 60 + parseInt(modelMinute);
            if(time == 0){
              this.$toast('请选择正确的时长');
              this.timeModelShow = true;
              return;
            }else{
              chargingModelValue = time;
            }
          }else{
            this.$toast('请选择正确的时长');
            this.chargingModelShow = true;
            this.timeModelShow = true;
            return;
          }
          
        }
        // let isStandardFee = true;
        // if(this.beforeDiscount != null && this.accInfo.vipType == 1){
        //   isStandardFee = false;
        // }
        // console.log(this.accInfo.feePkId)
        if(!this.accInfo.feePkId){
           this.$dialog
            .alert({
              message: '充电桩暂无费率信息，无法充电，请联系管理员',
              confirmButtonText: "确认",
              confirmButtonColor: "#14CC80",
              closeOnPopstate: true,
            }).then(() => {
              this.$common.goBack();
            })
            .catch(() => {
              this.$common.goBack();
            });
          return;
        }
        startCharge(
          {
            accountPkId: accountPkId,
            deviceType: this.chargePrepareInfo.deviceType,
            elecFeePkId: this.accInfo.elecFeePkId,
            gunPkId: this.chargePrepareInfo.gunPkId ? this.chargePrepareInfo.gunPkId : this.readyForm.gunPkId,
            topSoc: this.soc,
            vipType: this.selectAccInfo.vipType,
            carNo: this.carNo,
            discountStrategy: this.couponType,
            chargingModel: this.chargingModel,
            chargingModelValue: chargingModelValue,
            isStandardFee: this.accInfo.standardFee,
            feePkId: this.accInfo.feePkId,
            staPkId: this.chargePrepareInfo.staPkId,
            consumptionPattern: this.consumptionPattern,
             enterWay: enterWay // 0 点击列表  1 扫描二维号
            // gunNumber: this.gunNumber,
            // licensePlateNo: this.chargePrepareInfo.carNo,
            // serialNo: this.chargePrepareInfo.serialNo,
            // serialNumber: this.serialNumber,
            // staFeePkId: this.chargePrepareInfo.chargeFeeVo.staFeePkId
          },
          true
        )
          .then((data) => {
            this.saveDiscountStrategy();
            if (data.status === this.$config.ajaxStatus) {
              if(data.data[0]){
                this.$router.replace({
                  name: "charge/launching",
                  query: {
                    // accountPkId: accountPkId,
                    // gunNumber: this.gunNumber,
                    // serialNumber: this.serialNumber,
                    orderNo: data.data[0],
                    replace: true
                  },
                });
              }else{
                this.$toast("启动失败,没有订单号");
              }
            }else if(data.code == 302056){
              this.$dialog
                .confirm({
                  message: '请先输入车牌号或设置为默认车牌号后，再进行充电',
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                }).then(() => {
                  this.goSelectCar();
                })
            } else {
              this.$dialog
                .alert({
                  message: data.msg + this.$common.codeMsg(data.code),
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                }).then(() => {
                  this.$common.goBack();
                })
                // .then(() => {
                //   clearTimeout(this.timer);
                //   clearTimeout(this.getTimer);
                //   this.refresh();
                // })
                // .catch(() => {});
            }
          })
          .catch((error) => {
            console.log(error);
            this.$toast("启动失败");
          });
      }
    },
    openSoc() {
      this.$refs.selectSoc.open();
      // this.popupShow = true;
    },
    // onConfirm(value) {
    //   this.soc = value;
    //   this.popupShow = false;
    // },

    // onCancel() {
    //   this.popupShow = false;
    // },
    initColumns() {
      let arr = [];
      let min = this.chargePrepareInfo.floorSoc || 30;
      for (let i = min; i <= 100; i++) {
        arr.push(i);
      }
      arr = arr.reverse();
      this.defaultIndex =
        arr.indexOf(this.soc) != -1 ? arr.indexOf(this.soc) : 0;
      this.columns = arr;
    },
    timeOut(){
      clearTimeout(this.timer);
      clearTimeout(this.getTimer);
    },
    // 充电模式 1.5.2 
    async chargingModeConfirm(){
      this.chargingModeCancel();
      if(this.consumptionPattern == '2'){
        this.$common.save('selectAccInfo',this.selectAccInfo)
        this.$router.push({
          name: "recharge-refund",
        });
      }else{
        await this.getCheckAcct();
        this.startCharge();
      }
    },
    async startChargeBtn(){
      
      if(this.accInfo.vipType == 3 || this.chargePrepareInfo.hlht || !this.oprInfo.hasOpenPrechargeRetired){
        // 企业或者配置上没有即充即退直接充电
        await this.getCheckAcct();
        this.startCharge();
      }else{
          // 个人弹出充电模式选择
          this.openChargingMode();
        
      }
    },
    openChargingMode(){
      this.chargingModeModel = true;
    },
    chargingModeCancel(){
      this.chargingModeModel = false;
    },
    async getRechargeRefundSuccess(money){
      this.consumptionPattern = '2';
      this.chargingModel = 3;
      this.modelMoney = money;
      await this.getCheckAcct();
      this.startCharge();
      
    },
    getRechargeRefundMoney(){
      let money = this.$common.get('recharge-refund-success');
      return money;
    },
    removeRechargeRefund(){
      if(this.getRechargeRefundMoney()){
        this.$common.remove('recharge-refund-success')
        this.$common.remove('chargingModelData')
        this.$common.remove('selectAccInfo')
        
      }
    }
    // end
  },
  
  beforeDestroy() {
    this.removeRechargeRefund();
    this.timeOut();
    // clearInterval(this.timer);
    // clearTimeout(this.timer);
    // clearTimeout(this.getTimer);
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/old/var.less";

.change-page {
  background: #f7f7f7;
  height: 100%;
  .ready-rate-box {
    margin-top: 0.2rem;
    padding: 0.2rem 0.2rem 0.25rem 0.2rem;
    background-color: #fff;
    display: flex;
    .ready-rate-icon {
      width: 0.5rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
    .ready-rate-flex {
      flex: 1;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #666666;
    }
    .before-discount{
      color:#999;
      text-decoration: line-through;
    }
    .ready-rate-header,
    .ready-rate-content {
      display: flex;

      .title,
      .rate-content {
        flex: 1;
        padding-right: 0.2rem;
      }
      .header-right {
        color: #14cc80;
        font-size: 0.18rem;
        line-height: 0.25rem;
        padding: 0.08rem;
      }
    }
    .ready-rate-header {
      margin-bottom: 0.1rem;
    }
    .ready-rate-content {
      margin-bottom: 0.2rem;
    }
    .ready-rate-content:last-child {
      margin-bottom: 0;
    }
  }
  .ready-hlhtrate-box {
    margin-top: 0.2rem;
    .hlht-box {
      display: flex;
      .hlht-time {
        color: #999;
      }
      .hlht-flex {
        flex: 1;
      }
    }
  }
  .account-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .ready-account {
    width: 7.1rem;
    border-radius: 0.1rem;
    background-color: #fff;

    .ready-account-title {
      padding: 0.4rem;
      color: #333333;
      font-size: 0.36rem;
      line-height: 0.42rem;
      text-align: center;
      font-weight: 500;
    }
    .ready-account-content {
      padding: 0 0.2rem;
      text-align: center;
      font-size: 0.26rem;
      line-height: 0.35rem;
      .ready-account-item {
        padding: 0.29rem 0.2rem 0.3rem 0.2rem;
        border: 1px solid rgba(151, 151, 151, 0.8);
        border-radius: 0.05rem;
        margin-top: 0.4rem;
      }
      .ready-account-item:first-child {
        margin-top: 0;
      }
      .ready-account-item.active {
        background: rgba(20, 204, 128, 0.1);
        border: 1px solid #8e9c96;
        color: #14cc80;
        position: relative;
        border-color: #14cc80;
      }
      .ready-account-item.active:after{
        content: '';
        position: absolute;
        width: 0.3rem;
        height: 0.25rem;
        right: 0;
        bottom: 0;
        background-image: url('../../../assets/image/active-img.png');
        background-size: 100% 100%;
      }
    }
    .overlay-btn {
      margin-top: 0.5rem;
      display: flex;

      .overlay-btn-flex {
        flex: 1;
        height: 0.92rem;
        font-size: 0.34rem;
        line-height: 0.48rem;
        padding: 0.22rem;
        box-sizing: border-box;
        text-align: center;
      }
      .overlay-btn-flex.confirm {
        position: relative;
        color: #14cc80;
      }
      // .overlay-btn-flex.confirm:after {
      //   content: "";
      //   height: 0.7rem;
      //   right: 0;
      //   top: 0.11rem;
      //   background-color: #eeeeee;
      //   width: 0.01rem;
      //   position: absolute;
      // }
      .overlay-btn-flex:active {
        background-color: #f5f5f5;
      }
    }
  }
  .stop-fare-container {
    padding: 0.2rem;
    background: white;
    margin-top: 0.2rem;
    .title {
      .flex-align-center();
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
      span {
        font-size: 0.28rem;
        color: #666666;
        line-height: 0.4rem;
        padding-left: 0.1rem;
      }
    }
    div:not(:first-child) {
      font-size: 0.28rem;
      color: #999999;
      margin-left: 0.4rem;
      margin-top: 0.1rem;
    }
  }
  .soc-value {
    font-size: 0.32rem;
    color: @main-color;
  }
}
.btn-box {
  padding: 0 0.5rem;
  margin-top: 0.2rem;
}
.lowest-charge {
  // margin: 0.2rem 0.5rem;
  margin-bottom: 0.2rem;
  background: rgba(255, 210, 152, 0.3);
  font-size: 0.18rem;
  color: #999999;
  line-height: 0.3rem;
  text-align: center;
}
.custom-title{
  img{
    width: 0.28rem;
  }
}

// .title-class {
//   font-size: 0.28rem;
//   color: #666666;
// }

.label-class {
  font-size: 0.26rem;
  color: #999999;
}

.coupon-tips{
  width: 7.1rem;
  .coupon-tips-title{
    padding-top: 0.3rem;
    font-size: 0.36rem;
    line-height: 0.42rem;
    color: #333;
    text-align: center;
  }
  .coupon-tips-content{
    padding: 0 0.3rem;
    .p-title{
      margin-top: 0.3rem;
      font-size: 0.26rem;
      line-height: 0.35rem;
      color: #333;
    }
    .p-content{
      margin-top: 0.1rem;
      font-size: 0.24rem;
      line-height: 0.38rem;
      color: #999;
    }
  }
  .coupon-btn{
    margin-top: 0.32rem;
    text-align: center;
    border-top: 0.01rem solid #EEEEEE;
    line-height: 0.93rem;
    font-size: 0.34rem;
    color: #14CC80;
  }
}
.coupon-type-item{
  line-height: 0.94rem;
  font-size: 0.32rem;
  color: #333;
  padding-left: 0.2rem;
  border-top: 0.01rem solid #eee;
  position: relative;
  display: flex;
  .name-div{
    width: 2rem;
  }
  .flex-div{
    flex: 1;
    padding-left: 0.2rem;
    padding-right: 0.6rem;
    font-size: 0.24rem;
    input{
      width: 60%;
      height: 0.55rem;
      border: 0.01rem solid #d5d5d5;
      border-radius: 0.04rem;
      margin-right: 0.2rem;
      padding: 0 0.2rem;
      box-sizing: border-box;
    }
  }
  .flex-div.no{
    padding-right:0
  }
  img{
    position: absolute;
    width: 0.3rem;
    right: 0.2rem;
    top: 0.28rem;
  }

}
.coupon-type-item:first-child{
  border: none;
}
.coupon-type-item.input-box{
  margin-top: 0.2rem;
  border: none;
  
}
.charging-moda{
  margin-top: 0.3rem;
  padding: 0 0.8rem !important;
  .van-radio{
    flex: 1;
  }
}
</style>
